import { EMPTY_STATE_TYPES } from "../../Patient.constants";

export { EMPTY_STATE_TYPES };

export const VARIANTS_CONFIG = {
  [EMPTY_STATE_TYPES.PRACTITIONER_NO_APPOINTMENTS]: {
    variant: "white",
    title: "No upcoming sessions scheduled.",
    text: "You don't have any upcoming sessions at the moment.",
  },
  [EMPTY_STATE_TYPES.PRACTITIONER_NO_PAST_APPOINTMENTS]: {
    variant: "white",
    title: "No past sessions scheduled.",
    text: "You don't have any past sessions at the moment.",
  },
  [EMPTY_STATE_TYPES.NOT_REGISTERED]: {
    variant: "primary",
    title: "You are not registered as a client.",
    text: "Schedule a consultation to get started with your practitioner.",
    buttonText: "Schedule a Consultation",
    buttonSize: "md",
  },
  [EMPTY_STATE_TYPES.PATIENT_NO_APPOINTMENTS]: {
    variant: "white",
    title: "Welcome to Nirva.",
    text: "Schedule your first consultation or session to get started.",
    buttonText: "Schedule a Consultation",
    optionalMessage:
      "Your upcoming and past sessions will appear here once scheduled.",
  },
};

export const TEXT_WITH_BUTTON_SX = { mb: 3 };
